import type { AuiHeaderElement } from '@avalara/types/skylab';
import { getAccessToken, getAuthLogin, getAuthLogout } from './helpers';

export type AuiHeaderElementTempFixed = AuiHeaderElement & {
  requestCurrentAccessToken: () => Promise<{ accessToken: string }>;
};
const getHeaderElement = () => document.querySelector<AuiHeaderElementTempFixed>('aui-header');

export const setHeaderLoginAndLogoutUrl = () => {
  const auiHeader = getHeaderElement();
  if (auiHeader) {
    auiHeader.loginUrl = getAuthLogin();
    auiHeader.logoutUrl = getAuthLogout();
  }
};

export const setHeaderProductName = (productName: string) => {
  const auiHeader = getHeaderElement();
  if (auiHeader) auiHeader.productname = productName;
};

export const hideHeaderSignIn = () => {
  const auiHeader = getHeaderElement();
  if (!auiHeader) return () => {};

  const hideAccountMenuClass = 'hide-account-menu';
  auiHeader.classList.add(hideAccountMenuClass);

  return () => {
    auiHeader.classList.remove(hideAccountMenuClass);
  };
};

export const setHeaderRequestCurrentAccessToken = () => {
  const auiHeader = getHeaderElement();
  if (auiHeader) {
    auiHeader.requestCurrentAccessToken = getAccessToken;
  }
};

export const hideHeaderUrlInQa = () => {
  let timeout: NodeJS.Timeout;
  const startTimeout = () => {
    const auiHeader = document.querySelector('[data-ref="aui-header.logo-product"]');
    if (auiHeader) {
      auiHeader.removeAttribute('href');
    } else {
      timeout = setTimeout(startTimeout, 100);
    }
  };
  startTimeout();
  setTimeout(() => clearTimeout(timeout), 10000);
};
